import { link } from '@stereoagency/sanity-schema';
import { LinkComponentProps } from '@stereoagency/ui';

type Link = Omit<typeof link.schema.link, '_type'>;

export default function linkAsProps(value?: Link): LinkComponentProps {
  return {
    rel: value?.linkType === 'external' ? 'noindex nofollow' : undefined,
    href: value?.url ?? '/',
    target: value?.linkType === 'external' ? '_blank' : undefined
  };
}
